import type { UseInventoryListsOptionsFetch } from '@openx/types/targeting/targetingHookTypes.ts';

// todo EXCH-12155
export const useInventoryListsOptionsFetch: UseInventoryListsOptionsFetch = () => {
  return {
    inventoryListsOptions: [],
    mapById: {},
    loading: false,
  };
};
